import React from 'react'
import { useChargingSessionsV1 } from 'src/Libs/e-mobility/charging-sessions'
import EMobilityWallboxCards from './EMobilityWallboxCards'
import EMobilityWallboxCardsSkeleton from './EMobilityWallboxCardsSkeleton'
import WallboxDynamicPriceAlert from './WallboxDynamicPriceAlert'
import { BannerLocations, BannerQueue } from 'src/Libs/banners'
import { useDynamicPowerPricesEnabledContext } from 'src/Libs/dynamic-power-prices/context/dynamic-power-prices-enabled-provider'

interface EMobilityWallboxProps {
  storageId: string
}

const EMobilityWallbox = ({ storageId }: EMobilityWallboxProps): JSX.Element => {
  const { isDynamicPowerPriceEnabledForWallboxes } = useDynamicPowerPricesEnabledContext()
  const { wallboxes, isLoading: wallboxesLoading } = useChargingSessionsV1(storageId)

  if (wallboxesLoading) {
    return <EMobilityWallboxCardsSkeleton />
  }

  return (
    <>
      <BannerQueue location={BannerLocations.Emobility} />
      {isDynamicPowerPriceEnabledForWallboxes && <WallboxDynamicPriceAlert />}
      <EMobilityWallboxCards wallboxes={wallboxes || []} isDynamicPrice={isDynamicPowerPriceEnabledForWallboxes} />
    </>
  )
}

export default EMobilityWallbox
